<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @closed="closed"
    center
    width="30%">
    <div class="dialogStatus-container">
      <span>关闭后将不能在开启，是否确认关闭</span>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import debounce from "@/utils/debounce.js";
export default {
  name: "changeStatu",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      row: {},
      title:''
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      console.log(row, "row");
      this.row = row;
      this.title = `关闭<${row.activityName}活动>状态`
    },
    submit() {
      debounce(async()=> {
        let appKeyMini = localStorage.getItem("appKeyMini");
        this.loading = true;
        const res = await MiniModel.zfbActivityStopMarket({
          appKey: appKeyMini,
          id: this.row.id
        }).finally(() => {
          this.loading = false;
        });
        console.log(res, "res==1=getZfbActivityPage");
        if(res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success"
          });
          this.$emit('change');
          this.dialogVisible = false;
        }else{
          this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      },1000,true)
    },
    closed() {
      console.log("closed");
      this.row = {};
    }
  }
};
</script>

<style scoped lang="less">
.dialogStatus-container{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/couponGroupNew/component/changeStatu.vue